import { Routes, Route } from 'react-router-dom';

//Components
import Index from '../Components/Index/Index.js';
import MedicosList from '../Components/MedicosList/MedicosList.js';
import Header from '../Components/Header/Header.js';

export const AdminRoutes = () => {
    return (
        <>
            <Header />
            <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/medicos" element={<MedicosList />} />
            </Routes>
        </>
    );
};